module.exports = __webpack_public_path__ + "static/media/setup_ai.6169935b.webp";